export { LoyaltyPromoCodeDialog } from './loyalty-promo-code-dialog';
